import { HttpParams } from '@angular/common/http';
import { OnInit } from '@angular/core';
import { Component, ViewChild } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { Table } from 'primeng/table';
import { Observable } from 'rxjs';
import { ComponentBase } from '../../core/_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../core/_infrastructure/classes/services/auth.service';
import { NotificationService } from '../../core/_infrastructure/classes/services/notification.service';
import { Tc } from '../../core/_infrastructure/types/common';
import { CorreosUsuarioService } from './correosusuario.service';
import { ReglaCorreoUsuarioViewModel } from './correosusuario.types';

@Component({
    selector: 'app-correosusuario-list',
    templateUrl: './correosusuario-list.component.html',
})
export class CorreoUsuarioListComponent extends ComponentBase implements OnInit {
    @ViewChild('tableSearch') turboTable: Table;

    listPais$: Observable<Tc[]>;

    resultReglaCorreoUsuarioList: ReglaCorreoUsuarioViewModel[];
    resultReglaCorreoUsuarioUntouchedList: ReglaCorreoUsuarioViewModel[];

    visibilitySpinner = false;
    habilitarGuardar = false;

    public isCollapsed = false;

    constructor(
        private router: Router,
        private fb: UntypedFormBuilder,

        protected notificacionService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private correosUsuarioService: CorreosUsuarioService,
    ) {
        super(authService, notificacionService, exceptionHandler);
    }

    ngOnInit() {
        this.form = this.fb.group({
            Regla: '',
            resultReglaFormArray: new UntypedFormArray([]),
        });
    }

    onSearchButton() {
        if (this.turboTable) {
            this.turboTable.first = 0;
        }

        this.Search();

        this.searchingButton = true;
        this.isCollapsed = true;
    }

    Search() {
        let params = new HttpParams();

        params = params.append('IdUsuario', this.loggedInUser!.Id);
        params = params.append('Regla', this.form.value.Regla);

        this.loading = true;
        this.correosUsuarioService.getReglasByFilter(params).subscribe(result => {
            this.resultReglaCorreoUsuarioList = result;
            this.resultReglaCorreoUsuarioUntouchedList = result;

            (this.form.controls.resultReglaFormArray as UntypedFormArray).clear();

            this.resultReglaCorreoUsuarioList.map((o, i) => {
                const control = new UntypedFormControl(o.Activo); // if first item set to true, else false
                (this.form.controls.resultReglaFormArray as UntypedFormArray).push(control);
            });

            this.loading = false;
            this.habilitarGuardar = true;
        });
    }

    onSubmit() {
        if (this.resultReglaCorreoUsuarioList) {
            this.visibilitySpinner = true;

            this.resultReglaCorreoUsuarioList.map((o, i) => {
                o.Activo = this.form.controls.resultReglaFormArray.value[i];
            });

            this.correosUsuarioService.Save(this.resultReglaCorreoUsuarioList).subscribe({
                next: () => {
                    this.addSuccessMessage('Reglas de Correo modificadas correctamente');
                    this.visibilitySpinner = false;
                    this.Search();
                },
                error: error => {
                    this.visibilitySpinner = false;
                },
            });
        }
    }

    onCleanButton() {
        this.form.patchValue({
            Regla: '',
        });

        this.resultReglaCorreoUsuarioUntouchedList.map((o, i) => {
            this.form.controls.resultReglaFormArray.value[i] = o.Activo;
        });

        this.searchingButton = false;
        this.isCollapsed = false;
        this.habilitarGuardar = false;
    }
}
